module.exports = __webpack_public_path__ + "static/media/monde1_bg_flower.3ba3717c.png";